import {useState} from "react";
import useMerchantPortalAxios, {useMerchantPortalFormData} from "../utils/axios";
import {useNavigate} from "react-router-dom";
import useGenerateToken from "../authentication/GenerateToken";
import useLoginAPI from "./loginAPI";
import {setFlag, setLoading} from "../features/responseSlice";
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";

const MerchantInformationAPI = () => {

    const MerchantPortalAxios = useMerchantPortalAxios();
    const [GetMerchantsInfoList, SetMerchantsInfoList] = useState([]);
    const [merchantLoading, setMerchantLoading] = useState(true);
    const {generateRefreshToken} = useGenerateToken();
    const {CheckQrStatus} = useLoginAPI();
    const MerchantPortalClient = useMerchantPortalFormData();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    async function GetMerchantInformation() {
        await MerchantPortalAxios.post(
            `/v1/MerchantInformation/GetMerchantInformation`,
            {
                SessionID: sessionStorage.getItem("SessionID"),
            }
        ).then((res) => {
            SetMerchantsInfoList(res.data.Payload);
            setMerchantLoading(false);
        });
    }

    async function SaveUserEmployeeSelectedMerchant(merchant) {
        try {
            dispatch(setLoading("globalPending"))
            const res = await MerchantPortalAxios.post(
                "/v1/MerchantInformation/SaveUserEmployeeSelectedMerchant",
                {
                    SessionID: sessionStorage.getItem("SessionID"),
                    NewEntityID: merchant.MerchantID || merchant.LegalEntityID
                }
            );

            sessionStorage.setItem("EntityID", merchant.MerchantID || merchant.LegalEntityID);
            sessionStorage.setItem("EntityName", merchant.MerchantName || merchant.LegalEntityName);
            sessionStorage.setItem("MerchantIconURL", merchant.MerchantIconURL || merchant.LegalEntityIconUrl);
            sessionStorage.setItem("navClick", "Overview");

            setTimeout(() => navigate(0), 1000);
            await generateRefreshToken(sessionStorage.getItem("SessionID"), sessionStorage.getItem("RefreshToken"));
            await CheckQrStatus(null, null);
        } catch (e) {
            toast.error("An Error has occurred while changing merchant!");
        }
    }

    async function ManageAutoExchange(payload) {
        const res = await MerchantPortalAxios.post(
            "/v1/MerchantInformation/ManageAutoExchange",
            payload
        );
        return res;
    }

    async function EditMerchantInfo(payload) {

        if (payload.NewLogoImage) {
            const fileData = payload.NewLogoImage.split(',')[1];
            const mimeType = payload.NewLogoImage.split(':')[1].split(';')[0];
            const byteCharacters = atob(fileData);
            const byteArrays = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteArrays[i] = byteCharacters.charCodeAt(i);
            }
            payload.NewLogoImage = new File([byteArrays], payload.NewLogoImageName, {type: mimeType});
        }

        if (payload.NewCoverImage) {
            const fileData = payload.NewCoverImage.split(',')[1];
            const mimeType = payload.NewCoverImage.split(':')[1].split(';')[0];
            const byteCharacters = atob(fileData);
            const byteArrays = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteArrays[i] = byteCharacters.charCodeAt(i);
            }
            payload.NewCoverImage = new File([byteArrays], payload.NewCoverImageName, {type: mimeType});
        }

        const res = await MerchantPortalClient.post(
            "/v1/MerchantInformation/EditMerchantInfo",
            payload
        );
        return res.data.Payload;
    }

    const EditPaymentConfig = (merchId, paymentConfig) => {
        return MerchantPortalAxios.post(
            "/v1/MerchantInformation/EditPaymentConfig",
            {
                SessionID: sessionStorage.getItem("SessionID"),
                MerchantAccountID: merchId,
                PaymentConfig: paymentConfig
            }
        ).then(()=>{
            dispatch(setFlag(1));
        })
    }


    return {
        GetMerchantInformation,
        SaveUserEmployeeSelectedMerchant,
        ManageAutoExchange,
        GetMerchantsInfoList,
        merchantLoading,
        EditMerchantInfo,
        EditPaymentConfig
    };
};

export default MerchantInformationAPI;
